<template>
    <div id="box">
        <div class="text">地址：高新区科普路108号</div>
        <div id="number" class="text">苏ICP备14022536号 苏教S4-20120008号</div>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
#box {
    height: 70px;
    background-color: #4C4C4C;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top:20px;
    position:fixed;
    bottom:0;
    left:0;
    right:0;
}
.text{
    font-size:14px;
    color:rgba(255,255,255,1);
    line-height:19px;
}
#number{
    margin-top: 10px;
}

</style>
